import { Compliance_Cases } from 'generated';
import { useLocation, useNavigate } from 'react-router-dom';

type ParamKey = Extract<keyof Compliance_Cases, 'caseId'>;

type ComplianceState = {
  [key in ParamKey]: Compliance_Cases[ParamKey] | null;
};

export const useComplianceParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const complianceState: ComplianceState = {
    caseId: params.get('caseId'),
  };

  const setParam = <T extends ParamKey>(key: T, value: string | number) => {
    params.set(key, String(value));
    navigate({ pathname: location.pathname, search: params.toString() });
  };

  const clearParam = (key: ParamKey) => {
    params.delete(key);
    navigate({ pathname: location.pathname, search: params.toString() });
  };

  return { ...complianceState, setParam, clearParam };
};
